import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AbstractRestService, GenericLambdaReturn } from '@gea-mes/cognito';

@Injectable({
  providedIn: 'root'
})
export class PlantListService  extends AbstractRestService{

  postInit(): void { }

  plantList():Observable<GenericLambdaReturn<PlantType>>  {
    return this.get({
      ApiResource: "/configplantlist",
      repeatCall: false
    });    
  }

  lineList():Observable<GenericLambdaReturn<LineListType>>  {
    return this.get({
      ApiResource: "/config/lines",
      repeatCall: false
    });
  }

}

export type PlantType = {
  plantid: number;
  displayName: string;
  site: string;
  environment; string
}

export type LineListType = {
  Lines: LineType[];
  SubLines: SubLineType[];
}

export type LineType = {
  display_name: string;
  line_id: number;
  line: string;
}

export type SubLineType = {
  line_id: number;
  subline_id: number;
  subline: string;
}